export const drawerItemsMain = [
  {
    key: "ScanByOperator",
    title: "operationalScans",
    routes: [
      {
        nav: "ScanByOperator",
        routeName: "ScanByOperator",
        title: "operationalScans",
      },
    ],
  },
];
